// Simulación de datos que vendrían de la BBDD
export const infoData = {
  logotema: '/logotema.png',
  imagen_info: '/tratamientos/general/info-ejemplo.png', // ejemplo de ruta, cámbiala según tu imagen
  texto: [
    'Braineka es una plataforma de neuroterapia digital para superar fobias, miedos, depresión y más. Permite a psicólogos y pacientes acceder a tratamientos personalizados con imágenes, sonidos y palabras configurables.',
    'Para más información, contacta a tu neuroterapeuta.'
  ]
};
